<template>
  <EditPropertyPopularFilters
    v-if="isOpen"
    @closeEditing="closeEditing"
    :isOpen="isOpen"
    :currentPopularFilters="popularFilters"
    :allCurrentFilters="currentFilters"
  />
  <div v-if="hasPlus && !isLoading" class="tw:bg-blue-100 tw:border tw:border-blue-600 tw:rounded-xl tw:px-5 tw:py-4">
    <div class="tw:flex tw:items-center tw:mb-2">
      <Bulb class="tw:w-3 tw:h-5" />
      <h4 class="tw:font-bold tw:ml-1">{{ $t('business_studio_plus_tip') }}</h4>
    </div>
    <div>
      <h4 class="tw:font-bold tw:text-xl tw:mb-1">{{ $t('business_studio_plus_tip_header') }}</h4>
      <p v-html="$t('business_studio_plus_tip_text')" />
    </div>

    <div class="tw:flex tw:justify-between tw:mt-4 tw:items-end tw:md:items-center">
      <div class="tw:flex tw:flex-wrap tw:xl:flex-nowrap tw:gap-x-6 tw:gap-y-4">
        <div class="item tw:flex tw:items-center tw:gap-x-2" v-for="item in allPopularFilters" :key="item.featureId">
          <img :src="imageMapping[item?.featureId]" />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <GhostButton size="medium" @click="openEditing">{{
        popularFilters?.length > 0 ? $t('app_hotel_details_edit') : $t('app_hotel_details_add')
      }}</GhostButton>
    </div>
  </div>
  <div v-if="!hasPlus && !isLoading" class="tw:bg-blue-100 tw:border tw:border-blue-600 tw:rounded-xl tw:px-5 tw:py-4">
    <div class="tw:flex tw:items-center tw:mb-2">
      <Bulb class="tw:w-3 tw:h-5" />
      <h4 class="tw:font-bold tw:ml-1">{{ $t('business_studio_plus_tip') }}</h4>
    </div>
    <div class="tw:flex tw:items-end tw:justify-between">
      <div class="tw:mr-8">
        <h4 class="tw:font-bold tw:text-xl tw:mb-1">{{ $t('business_studio_plus_tip_upgrade_header') }}</h4>
        <p v-html="$t('business_studio_plus_tip_upgrade_text')" />
      </div>
      <MainButton @click="redirectToPlus" class="tw:text-nowrap"
        ><span class="tw:text-nowrap">{{ $t('business_studio_plus_upgrade_cta') }}</span></MainButton
      >
    </div>
  </div>
  <div v-if="isLoading">
    <div class="tw:animate-pulse tw:rounded-xl tw:bg-gray-200 tw:h-[198px] tw:w-full" aria-hidden="true"></div>
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import GhostButton from '@/components/base/buttons/GhostButton.vue'
import Bulb from '@/components/icons/Bulb.svg?component'
import EditPropertyPopularFilters from '@/components/propertyDetails/propertyPopularFilters/EditPropertyPopularFilters.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'

import appAnalytics from '@/utils/tracking'

import { useStudioPlusCampaign } from '@/components/payment/queries'
import { selectedAccommodationId } from '@/layouts/queries'

const router = useRouter()
const route = useRoute()
defineProps({
  allPopularFilters: Array,
  popularFilters: Array,
  currentFilters: Array,
})

onMounted(() => {
  window.localStorage.setItem(`property_details_news_${selectedAccommodationId.value}`, true)
})

watch(
  selectedAccommodationId,
  () => {
    window.localStorage.setItem(`property_details_news_${selectedAccommodationId.value}`, true)
  },
  { immediate: true }
)
const isOpen = ref(false)
const closeEditing = () => {
  isOpen.value = false
  if (route.query.open_filters) {
    const query = { ...route.query }
    delete query.open_filters
    router.replace({ query })
  }
}
const openEditing = () => {
  appAnalytics.track(appAnalytics.events.PD_ADD_POPULAR_FILTER_CLICKED, { itemId: selectedAccommodationId.value })
  isOpen.value = true
}

const paw = new URL(`../../../assets/img/property-details/paw.svg`, import.meta.url)
const spa = new URL(`../../../assets/img/property-details/spa.svg`, import.meta.url)
const pool = new URL(`../../../assets/img/property-details/pool.svg`, import.meta.url)
const wifi = new URL(`../../../assets/img/property-details/wifi.svg`, import.meta.url)
const kitchen = new URL(`../../../assets/img/property-details/kitchen.svg`, import.meta.url)
const parking = new URL(`../../../assets/img/property-details/parking.svg`, import.meta.url)
const airConditioning = new URL(`../../../assets/img/property-details/snowflake.svg`, import.meta.url)

const imageMapping = {
  25: parking,
  30: paw,
  732: wifi,
  60: spa,
  658: pool,
  86: airConditioning,
  255: kitchen,
}

const { isExpiredSubscription, isPlus, isPro, isLoading } = useStudioPlusCampaign(selectedAccommodationId)
const hasPlus = computed(() => {
  return (isPlus.value || isPro.value) && !isExpiredSubscription.value
})

const redirectToPlus = () => {
  router.push({ name: 'studio-plus-compare' })
}

onMounted(() => {
  if (route.query.open_filters) {
    openEditing()
  }
})

watch(
  () => route.query,
  newQuery => {
    if (newQuery.open_filters) {
      openEditing()
    }
  }
)
</script>
<style scoped>
.item {
  flex: auto 0 0;
  @media (max-width: 768px) {
    flex: 45% 0 0;
  }
}
</style>
